<template>
	<div class="business-article">
		<div class="column">
			<div class="content">
				<div class="content-inner u-pt4em-pc">
					<p class="content-catch u-LS10-pc u-MT2em-sp">
						「サイエンス」に裏付けられた「エンジニアリング」サービス
					</p>
					<div class="content-text">
						<p>
							当領域のコンサルティングでは、「デジタル時代のビジネス成長のために、今挑戦すべきことは何か？」に答えられることを重視しています。問いはシンプルですが、顧客が置かれている状況や将来像により回答は様々です。私たちのお客様は、デジタル化による環境変化から、高速・高頻度・高成功率で顧客価値提供を可能とする必要性に迫られています。
						</p>
						<p>
							私たちは、科学的なアプローチと合理的な業務改革と実装を行うエンジニアリングを両輪として、お客様のビジネス価値の最大化に向けたデータ活用コンサルティングサービスとデジタルソリューション活用を提供しています。
						</p>
						<p>
							豆蔵がデータおよびデジタル技術による変革をビジネスとして取組み始めたのは、2011年と古く、当時注目されていたビッグデータの活用や政府、自治体が保有するオープンデータを対象としたデータ分析ノウハウの獲得による人材育成事業がスタートであり、データとデジタル技術の活用を専門的に支援する組織として2015年にDX・AIソリューション領域が組織化されました。
						</p>
						<p>
							以降、AI/機械学習の採用やデジタル化によるLOB（Line Of
							Business：ライン部門）の業務プロセスの劇的な改善を行うRPAソリューションやノーコード、ローコード開発の導入支援にも支援領域を拡大してきました。
						</p>
						<p>
							このように事業を拡大してくる中で、DXを成功に導くためには、お客様自身が課題や取組みに腹落ちしていただくこと、継続的な改善のために内製化等の取組みを視野に入れていただくことが重要と考えています。
						</p>
						<p>
							そのために我々のサービスは、先進テクノロジの利用を目的とするのではなく、お客様がお持ちの課題の共有から仮説の設定、解決策の検証、運用と評価に至るまでを伴走型で提供しています。
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 領域の強み -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					DX・AIソリューション領域の強み
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt6em-pc">
					<div class="content-lead">
						<div class="content-num content-num--1">
							<img src="../../assets/common/num01.svg" alt="1" width="51" height="52" />
						</div>
						<p class="content-catch">高度なデータ解析スキルを保有するサイエンティスト</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							在籍するデータサイエンティストは、手元のデータのみの視野で分析を行うのではなく、データと分析知識を用いてお客様のビジネス課題を解決することをゴールとして取組みます。データ分析プロジェクトでは、ビジネス課題の解決をゴールとして、仮説、検証、モデル構築、評価を行い、実際にビジネスで利用されるシステムへの実装を確実に行います。<br />お客様との会話の中で、お客様ご自身が気づいていなかった課題や解決策を発見することもあります。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num02.svg" alt="2" width="62" height="52" />
						</div>
						<p class="content-catch">ビジネス価値を訴求する<br />DXプロジェクト推進フレームワーク</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							昨今の新規事業創出や変革を試行するようなプロジェクトでは、開始のタイミングでは、プロジェクトステージとタスクや期間、成果イメージが不明確であるケースが多々あります。我々は、このようなプロジェクトに対して豆蔵のソフトウェア開発、プロジェクト推進ノウハウが効果を発揮します。お客様の内製化につながるプロジェクト成果物をまとめあげることで、プロジェクトの規模に関わらず最適な道筋を示すことができます。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num03.svg" alt="3" width="63" height="52" />
						</div>
						<p class="content-catch">データ活用と連携技術ノウハウの集大成、<br />自社開発プロダクト</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							お客様の課題であった、蓄積された言語データの活用によるナレッジマネジメントをきっかけとして、問いに対してAIを用いた対話を行うチャットボットを開発しました。このチャットボットは、お客様の「出来たらいいな」の機能を段階的に追加していくことで、RPAや他クラウドサービス、業務の自動化指示等のDX基盤への支持の窓口として発展してきています。本プロダクトで使用されているAIを使ったナレッジ検索技術の独自性により特許を保有しています。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num04.svg" alt="4" width="65" height="52" />
						</div>
						<p class="content-catch">アカデミック知見のビジネス応用への連携</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							豆蔵では、最新の技術情報を最適な状態で実装する可能性を探るため、アカデミックな場の近くで相互にビジネスシーン、テクノロジとユースケースを共有する機会を重視しています。データサイエンス領域、データマーケティング領域において国内外の研究動向を先取りして知識の獲得と実践利用を可能にする取組みは、長期的な知見を取り入れることにつながっています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 代表的なプロジェクト事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					代表的なプロジェクト事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pb5em-pc">
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--1">
								<img src="../../assets/dxai/icon_display.svg" alt="" width="81" height="68" />
							</div>
							<p class="content-iconText">データ分析モデル <br />環境構築支援</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">製造系企業のデータ分析モデル、環境構築支援</p>
							<p>
								様々な企業が、自社が保有するデータを有効に活用して、新規事業の創発に取組んでいます。豆蔵は、お客様が持つAIデータ分析モデルをサービスの中で継続的に利用可能とするデータ基盤構築とモデルの最適化維持となるシステムの実現を支援しています。データサイエンスとエンジニアリングの両面を知る立場でプロジェクトを担当することでお客様の課題解決に寄与しました。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--2">
								<img src="../../assets/dxai/icon_person.svg" alt="" width="65" height="78" />
							</div>
							<p class="content-iconText">DX人材育成</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">受講者自身が自律的に知識を獲得（ＤＸ人材育成）</p>
							<p>
								DX人材の育成に取組む企業は数多く存在します。先進技術のビジネス利用を実際に進めるためには、インプット型の知識獲得に加えて、お客様自身の課題解決に取組むことを可能とする試行錯誤と検討結果をアウトプットする学習スタイルが有効であると考えます。<br />豆蔵では、PBL：Project
								Based
								Learningという手法を用いて、顧客の課題、データを題材とした仮想プロジェクトによる学習成果を出すことができました。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--3">
								<img src="../../assets/dxai/icon_robot.svg" alt="" width="94" height="83" />
							</div>
							<p class="content-iconText">
								DXソリューション
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								大手総合商社の統合窓口となるＤＸソリューション導入
							</p>
							<p>
								大手総合商社をお客様としたプロジェクトでは、デジタル化推進による徹底的な効率化を実現するためにRPAやチャットボットなどの複数のデジタルソリューションの導入を行っています。導入にあたって、単に製品導入に留まらず、マインド醸成につながるRPAロボットコンテストの開催や、業務プロセスの可視化支援、利用者研修に至るデジタルソリューション導入で必要となる全工程における統合的な窓口となりデジタル変革の技術パートナーとして継続した支援を行っています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--3">
								<img src="../../assets/dxai/icon_space.svg" alt="" width="85" height="65" />
							</div>
							<p class="content-iconText">
								その他
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								その他事例
							</p>
							<p>
								・衛星データ活用事業検討<br />顧客が保有するデータやセンサー技術で取得できるデータと衛星データを組み合わせることで、新たな知見の発見や新規事業のアイデア発想と技術検証
							</p>
							<p>
								・AIの民主化を実現するプラットフォーム企画<br />AI/機械学習技術の利用におけるハードルを取払い、AIの利用範囲を拡大することを目的とした「説明可能AI」、「MLOps」等の先進的な研究成果を活用したプラットフォームの企画。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- 領域の組織構成 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					DX・AIソリューション領域の組織構成
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt5em-pc u-pb3em-pc">
					<div class="content-text u-mt0">
						<p class="lg u-font-ots u-mt0">
							プロジェクトを通じた成長を続ける精鋭組織
						</p>
						<p>当事業部は総勢30名弱でチームに分かれ活動しています。</p>
						<p>
							データ活用による価値創造と内製化を組織力強化の観点で支援するコンサルティングを行う2チームと、RPA、ノーコード、ローコードの導入、自社プロダクトMZbotの開発、導入支援を行う2チームのメイン業務を軸とした組織の計4チームです。マネジメントラインとなるチームは上記の4つに分かれますが、実際にコンサルティングを行う際に複数メンバで構成されるプロジェクトでは、保有する技術や社員のキャリア目標により体制化して、案件の中からも学びと成長をつなげていきます。
						</p>
						<p class="lg u-font-ots u-mt3em">
							技術習得と発信を積極的に行う仮想組織
						</p>
						<p>
							プロジェクト外でも、自身のテーマを追求した結果として習得した知識や技術を発信する組織を構成しています。横串で切磋琢磨することで、技術者としての成長を図ります。同チームの活動は、豆蔵の技術情報ページからも発信情報を確認いただくことが可能です。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 今後の展望 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					今後の展望
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/dxai/photo01.jpg" alt="" width="1840" height="600" />
			</div>
			<div class="content">
				<div class="content-inner underImage u-pb3em-pc">
					<p class="content-catch">
						先進技術を用いて、企業のデジタル競争力強化、<br class="over_display" />ビジネス課題の解決を行う
					</p>
					<div class="content-text u-mt2em-pc">
						<p>
							データ活用が研究や概念検証から実際にビジネス課題、社会課題の解決につながるDXの推進リソースへと変化してきました。DX・AIソリューション領域のミッションは、先進技術を用いて、あらゆる企業のデジタル競争力の強化、ビジネス課題の解決を実現することです。
						</p>
						<p>
							技術の発展により、主流となる技法やソリューションは変化していくことは容易に予想されますが、お客様の課題を解決するという姿勢と先進技術についてトップランナーでありつづけることは変わりません。
						</p>
						<p>
							我々のお客様のデジタル戦略に沿って最適なデジタル技術の採用と内製化による課題解決を協創で実現します。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 求める人物像 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					求める人物像
				</h3>
			</div>
			<div class="content">
				<div class="content-inner bgGray u-pt4em-pc">
					<p class="content-catch u-LS10-pc u-wsn-pc">
						常に新しいことに挑む人。<br class="over_display" />与えられた課題を解くだけでなく自ら課題の設定を行う人。
					</p>
					<div class="content-text u-mt3em-pc">
						<p>
							前述のDXプロジェクトの特徴でも紹介した通り、デジタルによる変革はこれまで体験したことのないゴールを目指して進むことが多いことからも、決まった手順や枯れた技術、硬直化した思考では課題解決に至ることができません。
						</p>
						<p>
							新しい技術の可能性や、お客様の戦略に基づいたビジネス価値は何かを、仮説として設定し検証の試行錯誤を繰り返すこと、そしてその過程と成果をお客様に伝えることができる人が求められています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 活躍事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner u-ls10-pc">
					活躍事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt65em-pc">
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Aさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								国立大学で惑星大気物理学を専攻、理学博士。NASAのプロジェクトにおいてデータ分析技術を用いた火星大気の研究を担当し、学術・研究分野でのキャリアを持っています。
							</p>
							<p>
								自身が研究活動で培った成果の社会実装の場として豆蔵に入社しました。入社直後は、データサイエンスや機械学習に関わるプロジェクトがメインでしたが、知識の幅を広げ、現在では、システム導入運用のプロジェクトにも参画。データ分析モデルの実装等のデータエンジニアリング領域にも守備範囲を広げています。自身が研究で培った技術知識、思考方法やプロジェクトで得たノウハウを使ってお客様の役に立つことを、最も大事にして活動しています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Bさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								4年制大学の経済学部を卒業し、豆蔵に新卒入社しました。ITの力で多くの企業の課題を解決することが、国の発展につながるという想いを持ち、ITコンサルティング職を選択しました。
							</p>
							<p>
								担当しているのは、主に大手総合商社の業務のデジタル変革で用いられる、RPAやノーコード、ローコード開発等の業務改善を推進するソリューションの導入支援です。お客様が目指す業務が変わった後の姿を一緒に描くことで、単なるツール導入に留まらない質の高いコンサルティングを提供しています。
								お客様に感謝される、お客様の事業を変革できるITコンサルタントになることを目標に新技術習得にも積極的に取り組んでいます。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Cさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								私大教育学部数学科卒業後、国立大学大学院の情報理工学研究科に進学し、応用数学、実生活の問題のモデル化の可能性について研究を行いました。卒業後は、ソフトウェア開発会社にて医療系ソフトウェアの開発に従事し、要求・要件のモデル化、定義から開発、導入、保守までの一連のタスクを担当。
							</p>
							<p>
								豆蔵に入社後は、データサイエンスに関する知識とソフトウェア開発で培った経験を発展させて、自然言語処理を扱ったデータ分析プロジェクトに参画し、技術調査からプロトタイプ実装を担当しました。データサイエンスとエンジニアリングの広範な知見を保有していることから、DXの時代に求められる人材の役割モデルやスキルの設計、育成カリキュラムの策定プロジェクトでも活躍中です。子育て中のお母さんの顔も持ち、豆蔵初の時短による働き方改革のモデルケースとなりました。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー１ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num01_white.svg" alt="1" width="22" height="23"
					/></span>
					<span class="mid">少数精鋭のチームで、<br />社会の変革に<br />寄与できる会社</span>
					<span class="bottom">事業部長：Satoshi</span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/dxai/photo02.jpg" alt="" width="1500" height="904" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							前職は、大手のユーザ系企業で、システム企画・開発に従事してましたが、会社で敷かれたレールを走るより、自ら路を切り開き、新たな事がチャレンジができる環境で仕事がしたいとの想いで豆蔵へ2012年に転職しました。
						</p>
						<p>
							常に先端技術を取り入れながら、新しい価値をクライアントと協創し、事業を拡大中です。2021年より事業部長としてマネジメントを担っています。
						</p>
						<p>
							私たちの事業部は、AIなどのデータサイエンス技術と、アジャイル開発やデータマネジメントなどエンジニアリング技術の両方の技術を使いこなし、社会で使われるもの（価値のあるもの）を創りあげることができるやりがいのある案件が多いです。常に世の中の変化に対応しながら、サービスやソリューションを提供し続けている事業部なので、未知の領域に興味関心が強い方は、やりがいのある職場となっています。またサイエンティスト・エンジニアが成長できる仕事を提供できるように日々のマネジメントを心がけています。
						</p>
						<p>
							社員は、20代～30代のメンバーが数多く在籍し活気ある職場で、子育てしているメンバーや外国籍のメンバーなども複数名おり、多様性のある組織構成を目指しています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー２ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num02_white.svg" alt="2" width="28" height="23"
					/></span>
					<span class="mid">いつからでも学べる、<br />いつまでも成長できる環境</span>
					<span class="bottom">副事業部長：Tomoe</span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/dxai/photo03.jpg" alt="" width="1500" height="904" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							国内、外資のUNIXサーバシステムのエンジニアとしてITのキャリアを開始し、ITセキュリティと先進技術教育のコンサルティングを行ってきました。豆蔵入社後は、お客様のビジネス変革を実現するDX人材の育成計画立案から、実際の育成に至るプロジェクトを主に担当しています。現在セキュリティ専門の高等教育機関である情報セキュリティ大学院大学の博士後期課程にも在籍しています。
						</p>
						<p>
							専門家、技術者として成長するには「待ち」の姿勢ではうまくいきません。要求されている知見だけでなく、周辺技術、手法、そのアイデアが生まれた背景について理解していくことが必要です。そのためには、目前の要求に対して前後工程や知識の深掘りといった自分の専門性を広げていく思考が大切だと考えます。プロジェクトの進行中、場合によってはプロジェクトの終了後も、気になる知識をインプットし続けること、インプットした考えを整理して社内、社外にアウトプットする機会が多いため確実に成長することができます。
						</p>
						<p>
							また、長いキャリアを考えたときには、自分の「得意」を2軸持つことが仕事の幅を広げることにつながると考えます。一つの領域で行き詰ってしまった場合、抽象度をあげて考えるともう一つの得意分野の知識が突破口となったり、単純にリフレッシュすることで新しい考えが浮かんだりすることがあるからです。豆蔵が支援するプロジェクトは多岐に渡り、自然と２つの軸につながることも魅力だと思います。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー３ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num03_white.svg" alt="3" width="28" height="23"
					/></span>
					<span class="mid">基礎研究の<br />バックグラウンドを<br />存分に活かせる</span>
					<span class="bottom">チームリーダー：Shin-nosuke</span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/dxai/photo04.jpg" alt="" width="1500" height="904" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							宇宙物理学の研究者として、カリフォルニア大学やJAXAなどに勤めた後、2019年4月に豆蔵に入社しました。豆蔵ではAIをはじめとする先端技術によるデータ利活用支援及び人材育成サービスを担当しています。日本初の人工知能技術に特化した大学院研究科である立教大学大学院人工知能科学研究科にて特任准教授を兼務し、社会での応用を見据えた先端技術研究や、社会人学生を含む大学院生の研究指導も行っています。
						</p>
						<p>
							豆蔵への入社のきっかけは、基礎研究のバックグラウンドを持つ人たちの知見を生かして、世の中に影響を与えようとするスタンスに非常に共感したことです。AIソリューション領域では決まった仕事を繰り返せばよいということはなく常に創意工夫が求められ、基礎研究での課題解決経験をはじめ、意外な経験が役に立つ場面が数多くあります。豆蔵には様々なバックグラウンドを持つ優秀なITコンサルタントやエンジニアが多数在籍しており、それぞれ多様な専門分野を持っているので私自身も勉強になっています。
						</p>
						<p>
							現在私がリーダーを務めるAI技術チームでは、実社会への応用を見据え、最新の論文を読むなどの先端技術へのキャッチアップや、独自手法の開発、対外的な技術発信という大学の研究室に近いような活動を行っています。チームでの活動により得られた知見や開発した手法を顧客に提供した例も多数あります。チーム活動や衛星データ利活用の例のように、社員一人ひとりの持っている興味や知見を実際のビジネスに結びつけることができるのは、豆蔵の大きな魅力です。
						</p>
					</div>
				</div>
			</div>
		</article>

		<article class="column linkBox">
			<router-link to="/people_satoshi">
				<h3 class="linkBox_title">
					DX・AIソリューション領域<span class="over_display --inline">：</span
					><br class="under_display" />インタビュー記事はこちら
				</h3>
				<div class="linkBox_inner">
					<p class="linkBox_text u-font-ots">
						AI、IoT、データサイエンス。<br />大学教授ともタッグを組み、<br />「知」の力でブレイクスルーを起こす。
					</p>
					<picture class="linkBox_bg">
						<source srcset="../../assets/dxai/photo05_pc.jpg" media="(min-width: 1161px)" />
						<img src="../../assets/dxai/photo05_sp.jpg" alt="" />
					</picture>
				</div>
			</router-link>
		</article>
	</div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
	name: 'robot-article',
};
</script>

<style lang="scss" scoped>
// * {
// 	color: red !important;
// }
@keyframes gradientAnime {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
.business-article {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 0 auto;
	margin-bottom: 100px;
}
.column {
	position: relative;
	margin: 0 auto;
	margin-bottom: 140px;
	@media print, screen and (max-width: 1160px) {
		width: 90%;
		margin-bottom: 100px;
	}
	&:after {
		content: '';
		width: 150%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// top: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:before {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// bottom: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:nth-child(1) {
		&:after {
			content: none;
			// width: 150%;
			// top: 0;/
			// transform-origin: left top;
		}
		&:before {
			content: none;
			// width: 100%;
			// bottom: 0;
			// transform-origin: left top;
			// left: -50%;
		}
	}
	// ビジネスプラットフォーム領域の強み
	&:nth-child(2) {
		&:after {
			width: 150%;
			// top: 30%;
			// transform-origin: left top;
			// width: 100vw;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			// width: 100%;
			// bottom: -20%;
			// transform-origin: left top;
			// left: -50%;
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	// 代表的なプロジェクト事例
	&:nth-child(3) {
		&:after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
	// ビジネスプラットフォーム領域の組織構成
	&:nth-child(4) {
		&:after {
			width: 150%;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			content: none;
		}
	}
	// 今後の展望
	&:nth-child(5) {
		&:after {
			content: none;
		}
		&:before {
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	&:nth-child(n + 6) {
		&::after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
}

.column.keyman {
	@media print, screen and (min-width: 1161px) {
		margin-bottom: 0;
	}
	& + .column.keyman {
		@media print, screen and (min-width: 1161px) {
			margin-top: 60px;
		}
	}
	.content-inner {
		@media print, screen and (min-width: 1161px) {
			padding-bottom: 0;
		}
	}
	.keyman_flex {
		display: flex;
		flex-direction: column;
		align-items: center;
		@media print, screen and (min-width: 1161px) {
			flex-direction: row;
			align-items: flex-end;
		}
	}
	.keyman_title {
		display: flex;
		flex-direction: column;
		gap: 1em;
		position: relative;
		z-index: 1;
		width: 80vw;
		margin: 0;
		padding: 2em 0 2em 2em;
		box-sizing: border-box;
		font-family: 'ots-mincho', serif;
		background-color: #543193;
		color: #fff;
		@media print, screen and (min-width: 1161px) {
			justify-content: center;
			width: 380px;
			flex: 0 0 380px;
			padding: 2em 0 2em 3em;
			margin-right: -90px;
			margin-bottom: 40px;
		}
		span {
			display: block;
			img {
				display: block;
				width: 16px;
				@media print, screen and (min-width: 1161px) {
					width: 22px;
				}
			}
		}
		.top {
			display: flex;
			align-items: center;
			font-size: 12px;
			gap: 1em;
			font-weight: normal;
			@media print, screen and (min-width: 1161px) {
				font-size: 16px;
				letter-spacing: -0.05em;
			}
		}
		.mid {
			font-size: 19px;
			line-height: calc(70 / 38);
			font-weight: normal;
			letter-spacing: 0;
			@media print, screen and (min-width: 1161px) {
				letter-spacing: -0.05em;
				font-size: 26px;
				line-height: calc(50 / 26);
			}
		}
		.bottom {
			font-weight: bold;
			font-size: 12px;
			font-family: 'Noto Sans JP', sans-serif;
			letter-spacing: 0.1em;
			@media print, screen and (min-width: 1161px) {
				font-size: 14px;
			}
		}
	}
	.keyman_image {
		position: relative;
		z-index: 0;
		margin: -20px calc(50% - 50vw) 0;
		width: 100vw;
		@media print, screen and (min-width: 1161px) {
			flex: 0 0 630px;
			width: 630px;
			margin: 0;
		}
		img {
			vertical-align: bottom;
		}
	}
}
.title-wrap {
	top: -1.5em;
	display: inline-block;
	background-color: #543193;
	color: #fff;
	margin: 0;
	position: absolute;
	@media print, screen and (max-width: 1160px) {
		top: -30px;
		font-size: 12px;
	}
	h3 {
		font-family: 'ots-mincho';
		padding: 0 2em;
		text-align: left;
		position: relative;
		letter-spacing: 0.05em;
		font-weight: normal;
		@media print, screen and (min-width: 1161px) {
			padding: 0 3.5em;
			font-size: 16px;
			letter-spacing: 0;
		}
		&:before {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			left: 0;
		}
		&:after {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			right: 0;
		}
	}
}
.image {
	margin: 0 calc(50% - 50vw);
	width: 100vw;
	height: 32.67vw;
	@media print, screen and (min-width: 1160px) {
		margin: 0;
		width: 100%;
		height: 300px;
	}
	img {
		vertical-align: middle;
	}
}
.content {
	background-color: #fff;
}
.content-inner {
	padding: 120px 100px 3.5em 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 80px 5% 50px 5%;
	}
	&.grayBox {
		padding-top: 2.5em;
		padding-bottom: 1.5em;
		background-color: #e7e7e7;
		@media print, screen and (min-width: 1161px) {
			padding: 3em 50px;
		}
	}
	&.underImage {
		padding: 50px 100px 100px 100px;
		@media print, screen and (max-width: 1160px) {
			padding: 40px 5% 50px 5%;
		}
	}
	&.bgGray {
		background-color: #e7e7e7;
	}
}

.grayBoxContainer {
	display: flex;
	flex-direction: column;
	gap: 40px;
	@media print, screen and (min-width: 1161px) {
		flex-wrap: wrap;
		flex-direction: row;
		gap: 5px;
	}
}

.grayBox {
	position: relative;
	@media print, screen and (min-width: 1161px) {
		flex: 0 1 calc(50% - 5px);
		box-sizing: border-box;
	}
	&_title {
		display: inline-block;
		position: absolute;
		top: -1.5em;
		left: 50%;
		transform: translateX(-50%);
		background-color: #543193;
		width: 230px;
		padding: 1em 0;
		margin: 0;
		color: #fff;
		font-size: 12px;
		font-weight: bold;
		text-align: center;
		line-height: 1;
		letter-spacing: 0.05em;
		white-space: nowrap;
		@media print, screen and (min-width: 1161px) {
			box-sizing: border-box;
			width: 260px;
			font-size: 13px;
			padding: 1em 0;
		}
	}
	&_desc {
		font-size: 12px;
		line-height: 2;
		text-align: justify;
		text-justify: inter-ideograph;
		text-justify: inter-character;
		@media print, screen and (min-width: 1161px) {
		}
	}
}

.content-lead {
	&:not(:first-of-type) {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	@media print, screen and (min-width: 1161px) {
		display: flex;
		align-items: center;
		gap: 40px;
	}
}

.content-num {
	width: 31px;
	@media print, screen and (min-width: 1161px) {
		width: 37px;
	}
	&--1 {
		width: 25px;
		@media print, screen and (min-width: 1161px) {
			width: 30px;
		}
	}
	img {
		width: 100%;
	}
}

.content-iconFlex {
	@media print, screen and (min-width: 1161px) {
		display: flex;
		justify-content: flex-end;
		gap: 50px;
		.content-text {
			flex: 0 0 530px;
		}
	}
	& + & {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	&.--person {
		@media print, screen and (min-width: 1161px) {
			gap: 50px;
		}
	}
}
.content-iconFlex.--person + .content-iconFlex.--person {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2.5em;
	}
}

.content-iconContainer {
	display: flex;
	align-items: center;
	gap: 30px;
	@media print, screen and (min-width: 1161px) {
		flex: 1 1 auto;
		gap: 10px;
		flex-direction: column;
	}
	&.--person {
		gap: 0;
		flex-direction: column;
		.content-icon {
			@media print, screen and (min-width: 1161px) {
				width: 55px;
				margin-top: 5px;
			}
		}
	}
}
.content-icon {
	&--1 {
		width: 52px;
		@media print, screen and (min-width: 1161px) {
			width: 70px;
		}
	}
	&--2 {
		width: 45px;
		@media print, screen and (min-width: 1161px) {
			width: 65px;
		}
	}
	&--3 {
		width: 49px;
		@media print, screen and (min-width: 1161px) {
			width: 62px;
		}
	}
}

.content-iconText {
	font-size: 12px;
	font-weight: bold;
	margin: 0;
	@media print, screen and (min-width: 1161px) {
		font-size: 14px;
		text-align: center;
		white-space: nowrap;
	}
}

.content-catch {
	font-size: 26px;
	font-family: 'ots-mincho', serif;
	letter-spacing: 0;
	margin: 0;
	line-height: calc(42 / 26);
	@media print, screen and (max-width: 1160px) {
		margin-top: 0.5em;
		font-size: 18px;
		line-height: calc(68 / 36);
	}
}
.content-text {
	font-size: 12px;
	text-align: justify;
	margin-top: 4em;
	// @media print, screen and (min-width: 1161px) {
	// 	margin-top: 4em;
	// }
	&.--interview p {
		@media print, screen and (min-width: 1161px) {
			font-size: 14px;
			line-height: calc(30 / 14);
		}
	}
	p {
		font-family: 'Noto Sans JP', sans-serif;
		font-weight: 500;
	}
	p:not(:first-of-type) {
		margin-top: 2.5em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 2em;
		}
	}
	p.content-textLead {
		font-family: 'ots-mincho', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 1.5em;
		@media print, screen and (min-width: 1160px) {
			margin-top: -0.5em;
			font-size: 23px;
			line-height: calc(41 / 23);
		}
	}
	p.lg {
		font-family: 'Noto Serif JP', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 0;
		@media print, screen and (min-width: 1160px) {
			font-size: 26px;
			line-height: calc(61 / 26);
		}
	}
}
.case {
	background-color: #dddddd;
}
.case-inner {
	padding: 0 100px 50px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 0 5% 50px 5%;
	}
}
.case-title {
	font-size: 14px;
	background-color: #543193;
	color: #fff;
	display: inline-block;
	margin: 0;
	padding: 0 30px;
}
.case-text {
	font-size: 12px;
	margin-top: 40px;
	text-align: justify;
}
.case-catch {
	font-size: 17px;
}

.linkBox {
	@media print, screen and (min-width: 1161px) {
		margin-top: 140px;
		max-width: 830px;
	}
	&_title {
		display: inline-block;
		position: relative;
		margin: 0;
		padding: 1em 2em 1em 2.5em;
		background-color: #e7e7e7;
		color: #543193;
		font-weight: bold;
		font-size: 11.5px;
		line-height: calc(40 / 23);
		letter-spacing: 0.05em;
		@media print, screen and (min-width: 1161px) {
			font-size: 13px;
		}
		&::before {
			content: '';
			display: inline-block;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 1em;
			height: 2px;
			background-color: currentColor;
		}
	}
	&_inner {
		position: relative;
	}
	&_text {
		position: absolute;
		top: 50%;
		left: 1.5em;
		transform: translateY(-50%);
		margin: 0;
		font-family: 'Noto Serif JP', serif;
		color: #fff;
		letter-spacing: 0;
		font-size: 15px;
		line-height: calc(64 / 30);
		@media print, screen and (min-width: 1161px) {
			left: 3.5em;
			font-size: 24px;
			line-height: calc(53 / 24);
			letter-spacing: -0.1em;
		}
	}
	&_bg {
		display: block;
		source,
		img {
			vertical-align: bottom;
		}
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}

.u-bg0-pc {
	@media print, screen and (min-width: 1161px) {
		background-color: transparent !important;
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}
.u-mt2em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2em !important;
	}
}
.u-mt3em {
	margin-top: 3em !important;
}
.u-mt3em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 3em !important;
	}
}
.u-pb3em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 3em !important;
	}
}
.u-pt4em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 4em !important;
	}
}
.u-pt5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 5em !important;
	}
}
.u-pb5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5em !important;
	}
}
.u-pb55em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5.5em !important;
	}
}
.u-pt6em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6em !important;
	}
}
.u-pt65em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6.5em !important;
	}
}
.u-pt7em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 7em !important;
	}
}

.u-wsn-pc {
	@media print, screen and (min-width: 1161px) {
		white-space: nowrap !important;
	}
}

.u-LS10-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: -0.1em !important;
	}
}
.u-LS05-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: -0.05em !important;
	}
}

.u-ls0-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: 0 !important;
	}
}
.u-ls10-pc {
	letter-spacing: 0.1em !important;
}
</style>
